import { DbAssetObjectInfos } from "../Types/db-asset-object-infos";
import { GenericResponseStd } from "../Types/generic-response-std";
import { GetDetailedTmdbTitleRequest } from "../Types/get-detailed-tmdb-title-request";
import { GetDetailedTmdbTitleResponse } from "../Types/get-detailed-tmdb-title-response";
import { GetSearchTmdbTitlesResponse } from "../Types/get-search-tmdb-titles-response";
import { ImportArtworksResponse } from "../Types/import-artworks-response";
import { SearchTitleRequest } from "../Types/search-title-request";
import { SearchTitleResponse } from "../Types/search-title-response";
import { TitleType } from "../Types/title-type";
import { GetMetadataFieldsResponse } from "../Types/get-metadata-fields-response";
import ApiClient from "../api-client";
import { EnvType } from "../services";
import TitleApiClient from "./title-api-client";
import { CatalogReportingResponse } from "../Types/catalog-reporting-response";

export default class TitleService {
  titleApiClient: TitleApiClient;

  constructor(envType: EnvType) {
    this.titleApiClient = new TitleApiClient(new ApiClient(envType), envType);
  }
  async CreateTitle(request: DbAssetObjectInfos): Promise<GenericResponseStd> {
    return await this.titleApiClient.CreateTitle(request);
  }
  async UpdateTitle(request: DbAssetObjectInfos): Promise<GenericResponseStd> {
    return await this.titleApiClient.UpdateTitle(request);
  }
  async GetMetadataFields(): Promise<GetMetadataFieldsResponse> {
    return await this.titleApiClient.GetMetadataFields();
  }
  async SearchTmdbMovies(name: string, type: TitleType): Promise<GetSearchTmdbTitlesResponse> {
    return await this.titleApiClient.SearchTmdbMovies(name, type);
  }
  async GetDetailedTmdbTitle(request: GetDetailedTmdbTitleRequest): Promise<GetDetailedTmdbTitleResponse> {
    return await this.titleApiClient.GetDetailedTmdbTitle(request);
  }
  async ConnectSearchTitle(request: SearchTitleRequest): Promise<SearchTitleResponse> {
    return await this.titleApiClient.ConnectSearchTitle(request);
  }
  async ConnectLinkTitle(titleId: number, connectId: number): Promise<GenericResponseStd> {
    return await this.titleApiClient.ConnectLinkTitle(titleId, connectId);
  }
  async ConnectImportMetadata(titleId: number): Promise<GenericResponseStd> {
    return await this.titleApiClient.ConnectImportMetadata(titleId);
  }
  async ConnectImportArtworks(titleId: number): Promise<ImportArtworksResponse> {
    return await this.titleApiClient.ConnectImportArtworks(titleId);
  }
  async SyncTitleWithSpock(titleId: number): Promise<GenericResponseStd> {
    return await this.titleApiClient.SyncTitleWithSpock(titleId);
  }
  async GetCatalogReporting(): Promise<CatalogReportingResponse> {
    return await this.titleApiClient.GetCatalogReporting();
  }
  async GetCatalogReportingByTitle(titleId: number): Promise<CatalogReportingResponse> {
    return await this.titleApiClient.GetCatalogReportingByTitle(titleId);
  }
  async DownloadCatalogReportAsCSV(): Promise<GenericResponseStd> {
    return await this.titleApiClient.DownloadCatalogReportAsCSV();
  }
  //------Utils------
  GetServiceUrl(): string {
    return this.titleApiClient.GetApiUrl();
  }
}
